"use strict";

exports.__esModule = true;
exports.dataKey = void 0;
var dataKey = 'text';
exports.dataKey = dataKey;


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-form/lib/util/eventConsts.js
 ** module id = 1998
 ** module chunks = 0
 **/